import React from 'react';
import Dropzone from 'react-dropzone';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import { setFile } from 'actions/uploadImage';
import styles from './UploadImage.css';

const ConfirmDeleteModal = ({ onCancel, onDelete, show }) => {
  return (
    <Modal
      onHide={() => {}}
      show={show}
      dialogClassName={`modal-dialog ${styles['confirm-delete-dialog']}`}
    >
      <Modal.Header bsClass={`modal-header ${styles['confirm-delete-header']}`}>
        <Modal.Title>Information</Modal.Title>
      </Modal.Header>
      <Modal.Body>Are you sure to delete this image?</Modal.Body>
      <Modal.Footer>
        <span className="pull-right">
          <button className="btn btn-default" onClick={onCancel}>
            Cancel
          </button>
          <button className="btn btn-danger" onClick={onDelete}>
            Delete
          </button>
        </span>
      </Modal.Footer>
    </Modal>
  );
};

const UploadValidationModal = ({
  onHide,
  showUploadValidationModal,
  textModal,
}) => {
  return (
    <Modal
      onHide={onHide}
      show={showUploadValidationModal}
      dialogClassName={`${styles.dialog} modal-dialog margin-top-120`}
    >
      <Modal.Header>
        <Modal.Title className={styles['title-modal']}>Information</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>{textModal}</div>
      </Modal.Body>
      <Modal.Footer>
        <div>
          <button type="button" className="btn btn-default" onClick={onHide}>
            OK
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

class UploadImage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showUploadValidationModal: false,
      showConfirmDeleteModal: false,
      textModal: '',
      loading: false,
    };
  }

  render() {
    const {
      name,
      className,
      input: { value },
      defaultImage,
      placeholder,
      imageContainerClassName,
      backgroundColor,
      disableEditAndDeleteButton,
    } = this.props;
    const { loading } = this.state;
    const actionEditClassName = value
      ? styles['edit-button']
      : styles['edit-button-full'];
    return (
      <div className={`mk-brand-img-box ${className}`}>
        <div className={`image-preview ${styles['image-container']}`}>
          {!loading && !value && (
            <div
              style={
                defaultImage
                  ? { background: `url(${defaultImage})` }
                  : backgroundColor
                  ? { background: backgroundColor }
                  : { background: '#ddd' }
              }
              id="img-public-profile"
              className={`${
                styles['default-image-container']
              } ${imageContainerClassName}`}
            >
              {placeholder}
            </div>
          )}
          {!loading && value && <img src={value} id="img-public-profile" />}
          {loading && (
            <img
              src="http://mokapos.com/assets/item-image-loading.gif"
              id="img-public-profile"
            />
          )}
        </div>
        {!disableEditAndDeleteButton && (
          <div className="img-action-bar trans-1">
            <div className={`action ${styles.action}`}>
              <Dropzone
                name={name}
                className={actionEditClassName}
                onDrop={this._onDrop}
                accept="image/*"
                multiple={false}
              >
                Edit
              </Dropzone>
              {!!value && (
                <div className={styles['delete-button']}>
                  <span onClick={this._onClickDelete}>Delete</span>
                </div>
              )}
            </div>
          </div>
        )}
        <UploadValidationModal
          showUploadValidationModal={this.state.showUploadValidationModal}
          onHide={this._onHideValidationModal}
          textModal={this.state.textModal}
        />
        {this.props.confirmOnDelete && (
          <ConfirmDeleteModal
            show={this.state.showConfirmDeleteModal}
            onDelete={() => {
              this._onDelete();
              this.setState({ showConfirmDeleteModal: false });
            }}
            onCancel={() => {
              this.setState({ showConfirmDeleteModal: false });
            }}
          />
        )}
      </div>
    );
  }

  _onDrop = acceptedFiles => {
    const { afterUpload } = this.props;
    const fileReader = new window.FileReader();
    let header = '';
    fileReader.onloadend = e => {
      const arr = new Uint8Array(e.target.result).subarray(0, 4);
      for (let i = 0; i < arr.length; i++) {
        header += arr[i].toString(16);
      }

      const {
        input: { onChange },
        meta: { dispatch },
      } = this.props;
      const { type } = acceptedFiles[0];
      if (acceptedFiles[0].size >= 256000) {
        // show validation modal
        this.setState({
          showUploadValidationModal: true,
          textModal:
            'Error: Image file is too big, please upload less than 250 KB',
        });
      } else if (
        type !== 'image/jpg' &&
        type !== 'image/jpeg' &&
        type !== 'image/png' &&
        type !== 'image/gif'
      ) {
        this.setState({
          showUploadValidationModal: true,
          textModal: 'Error: Please upload valid image',
        });
      } else if (
        header !== 'ffd8ffe0' &&
        header !== 'ffd8ffdb' &&
        header !== 'ffd8ffe1' &&
        header !== '89504e47' &&
        header !== '47494638'
      ) {
        this.setState({
          showUploadValidationModal: true,
          textModal:
            'Error: The image has been tampered, please upload another one',
        });
      } else {
        onChange(acceptedFiles[0].preview);
        dispatch(setFile(acceptedFiles[0]));
        afterUpload();
        this.setState({
          loading: false,
        });
      }
    };
    fileReader.readAsArrayBuffer(acceptedFiles[0]);
  };

  _onClickDelete = () => {
    if (this.props.confirmOnDelete) {
      this.setState({
        showConfirmDeleteModal: true,
      });
    } else {
      this._onDelete();
    }
  };

  _onDelete = () => {
    const {
      input: { onChange },
      meta: { dispatch },
    } = this.props;
    onChange('');
    dispatch(setFile(null));
  };

  _onHideValidationModal = () => {
    this.setState({
      showUploadValidationModal: false,
      textModal: '',
    });
  };
}

function mapStateToProps(state) {
  const { deleted } = state.uploadImage.uploadImage;
  return { deleted };
}

UploadImage.propTypes = {
  name: PropTypes.string,
  files: PropTypes.object,
  onDrop: PropTypes.func,
  onDelete: PropTypes.func,
  beforeUpload: PropTypes.func,
  afterUpload: PropTypes.func,
  confirmOnDelete: PropTypes.bool,
  disableEditAndDeleteButton: PropTypes.bool,
};

UploadImage.defaultProps = {
  disableEditAndDeleteButton: false,
};

export default connect(mapStateToProps)(UploadImage);
